import { Experiences } from "@/getServerSideProps/monetate/getExperiences/experiencesSchema";
import { MonetateExperience } from "@JohnLewisPartnership/experiments-utils";

export const transformExperiences = (
  experiences: Experiences,
): MonetateExperience[] => {
  return experiences.map((experience) => ({
    ...experience,
    id: String(experience.experienceId),
    variantLabel: experience.variantLabel || "",
    impressionId: experience.impressionId || undefined,
    parameters: experience.parameters ? experience.parameters : {},
  }));
};
